<div style="padding-top:29px;">
    <button class="btn btn-outline-primary" (click)="openPickerModel()" [disabled]="field.templateOptions.disabled">
        Stakeholder responses
    </button>
</div>